export const submitVacation = (data) => {
    const url = `/users/${data.userId}/vacations`;

    return gofor(url, {
        method: 'POST',
        body: JSON.stringify(data)
    }).then((response) => response.json());
};

export const notify = (gigId) => {
    const gig =  typeof gigId !== 'undefined' ? gigId : Fiverr.models.ps.gig_id;
    const url = `/vacations/${gig}/waiting_customers`;

    return gofor(url, {
        method: 'POST'
    }).then((response) => {
        if (!response.ok) {throw new Error('');}
        return response.json();
    }).catch((err) => {throw err;});
};

/* eslint-disable */
const DATE_REGEX = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
const DATEPICKER_REGEX = /^\d{4}-\d{2}-\d{2}$/;
/* eslint-enable */

export const dateIsValid = (value) => {

    if (typeof value !== 'string') {
        return false;
    }

    if (!value.match(DATE_REGEX) && !value.match(DATEPICKER_REGEX)) {
        return false;
    } // Invalid format

    const d = new Date(value);

    const dTime =d.getTime();
    if (!dTime && dTime !== 0) {
        return false; // Invalid date
    }

    if (dTime < (new Date().getTime())) {
        return false; // Date in future
    }

    return true;
};

export const turnVacationOff = (username) => {
    const url = `/users/${username}/vacations`;

    return gofor(url, {
        method: 'DELETE'
    });
};

export const getDateString = (dateTimestamp) => {

    const dateObj = new Date(dateTimestamp * 1000);
    const dateString = dateObj.toLocaleString('en-us', { day:'numeric', month: 'short', year:'numeric' });

    return dateString;
};

/* Checks if the date exist and not in the past*/
export const isValidDate = (dateVal) => {
    const date = new Date(dateVal.yyyy, dateVal.mm-1, dateVal.dd),
        convertedDate = (date.getFullYear() + (date.getMonth()+1) + date.getDate()).toString(),
        givenDate = (dateVal.yyyy + dateVal.mm + dateVal.dd).toString(),
        today = new Date().setHours(0, 0, 0, 0);
    let sendDate = `${dateVal.mm}/${dateVal.dd}/${dateVal.yyyy}`;

    sendDate = Date.parse(sendDate);

    return (givenDate === convertedDate && sendDate >= today);
};

export const reportEvent = (type, data, other = false) => {

    const groupStr = other ? other : 'out_of_office',
        typeStr = `${!other ? 'out_of_office.' : ''}${type}`;

    let eventData = {
        type : typeStr,
        group: groupStr
    };

    eventData = Object.assign({}, eventData, {...data});


    Fiverr.sendClientEvents(eventData);
};


// WEBPACK FOOTER //
// ./src/helper.js